import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import WizardActionButtons from "../../Wizard/WizardActionButtons";
import { getXsrfToken } from "../../../Store/Security/Actions";
import { selectShippingMethod } from "../../../Store/Checkout/Actions";

class ShippingMethodForm extends Component {
    renderShippingMethods() {
        const { shippingMethods } = this.props;

        if (shippingMethods && shippingMethods.length > 0) {
            return _.map(shippingMethods, (shippingMethod, i) =>
                <option key={i} value={`${shippingMethod.name}___${shippingMethod.shippingRateComputationMethodSystemName}`}>{shippingMethod.name} ({shippingMethod.fee})</option>
            );
        }
    }

    onSubmit(values) {
        const { getXsrfToken, goNext, change, selectShippingMethod } = this.props;

        if (!values.ShippingMethod) {
            values.ShippingMethod = document.getElementsByName("ShippingMethod")[0].value;
            change("ShippingMethod", values.ShippingMethod);
        }

        getXsrfToken(({ token }) => {
            selectShippingMethod({
                Method: values.ShippingMethod,
                __RequestVerificationToken: token
            }, () => goNext());
        });
    }

    render() {
        const { handleSubmit, goPrev, wizardName } = this.props;

        return <form className="container" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <div className="row justify-content-md-center">
                <div className="col-md-6">
                    <div className="input-select">
                        <Field name="ShippingMethod" component="select">
                            {this.renderShippingMethods()}
                        </Field>
                    </div>
                </div>
            </div>
            <WizardActionButtons showPrev={true} showNext={true} goPrev={goPrev} wizardName={wizardName}/>
        </form>;
    }
}

function mapStateToProps(state) {
    return {
        shippingMethods: state.shippingMethods
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        selectShippingMethod: selectShippingMethod
    }, dispatch)
}

export default reduxForm({
    // validate,
    form: "CheckoutForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(
    connect(mapStateToProps, mapDispatchToProps)(ShippingMethodForm)
);